<sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
<mat-dialog-actions>
  <button mat-button color="success" (click)="submit()">{{ 'common.save' | t }}</button>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
</mat-dialog-actions>
